<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<section>

			<!-- 滚动大图 start -->


			<el-carousel trigger="click" height="500px" autoplay :interval="2000" id="bannercontain">
				<el-carousel-item v-for="(item, index) in imgarr" :key="index">
					<img class="img_pc" :src="item.file_url" ref="image" />
				</el-carousel-item>
			</el-carousel>
			<!-- end -->
			<div class="about-us">
				<div class="about-left">
					<p>关于我们</p>
					<img src="https://image.haojun.work/sys/show.png" />
				</div>
				<div class="about-right">
					<div>
						陕西领科新能源科技有限公司，是西安市市场监督管理局注册的一家集光伏发电项目、电动汽车充电桩、空气能项目投资、融资、合作生产、销售、安装项目建设的合作为一体的能源科技运营企业，是中国央企、国企、上市公司、民营企业的合作开发企业，近年来在合作企业的协助下，公司在陕西省西安市、铜川、渭南、汉中、横山、延川、新疆等地合作安装了一定体量的地面、工商业屋顶、居民屋顶光伏发电站，积累了一定的建设、安装经验。
					</div>
					<div>公司拥有一支专业的技术开发团队，以能源应用为基点，将光伏、储能、热能、汽车充电应用有效结合，
						从基础建设出发，将光能、储能、充电技术、空气能应用到客户的需求中。公司专注于光伏应用市场、
						电动汽车充电桩产品、空气能热泵技术的开发和应用，为客户提供安全、
						高效、经济的能源管理技术产品及完善的技术服务和解决方案。依靠科技求发展，
						不断为用户提供满意的光伏、电动汽车充电技术、空气能热泵技术的整体方案是我们始终不变的追求。
						公司以“发展新能源产业，创造清洁环保”为愿景，以“公平、责任、务实、超越、的原则，以信誉求发展、
						以质量求生存的经营理念，坚持“用户至上、合作共赢”的服务理念，已经与同仁达成相关合作协议，
						携手共进，加快了技术创新，提高了生活质量为目标，以建立和谐社会为宗旨，实现客户和企业的社会价值，
						通过能源技术革命让环境更友好。
					</div>
				</div>
			</div>


			<div class="content2">
				<div class="c_title">
					<h2>案例展示</h2>
					<p>case show</p>
				</div>
			</div>

			<div class="box ">
				<div class="row">
					<div id="content_img" class="content">
						<img class="content_img" v-for="(item, index) in list_min_img" :key="index"
							:src="item.file_url" />
					</div>
				</div>
				<!-- <ul class="row row-gundong">
					<li class="content" v-for="(item, index) in list_min_img" :key="index">
						<img class="content_img" :src="item.file_url" />
					</li>
				</ul>
 -->


			</div>

			<!-- <div class="box">
				<ul class="right_panelUp">
					<li v-for="(item, index) in list_min_img" :key="index">
						<span>{{item.file_url}}</span>
						<p class="line_one"></p>
						<p class="line_two"></p>
					</li>
				</ul>
			</div> -->

			<div class="content2">
				<div class="c_title">
					<h2>友情链接</h2>
					<p>LINK</p>
				</div>
			</div>

			<div class="box box-link">
				<div class="row row-link">
					<div class="my-link" v-for="(item,index) in list_link" :key="index"
						@click="look_news(item.out_url)">
						{{item.s_title}}
					</div>
				</div>
			</div>




		</section>


	</div>
</template>

<script>
	// import '@/assets/css/CSS.css';
	import {
		Message,
		GoUrl,
		GetRandom,
		checkStringByForm
	} from '@/utils/method.js';

	import {
		sysSelect
	} from '@/utils/systemSelect.js';

	import {
		BackSpecial
	} from "@/utils/localstore.js";

	import api from '@/utils/type.js'

	import {
		Sel_Mobile
	} from '@/utils/loadhttpdata.js';

	// const url = require("@/assets/verify/images/1.jpg");
	export default {
		data() {
			return {
				element_loading: false,


				list_min_img: [],
				defaultimage: 'this.src="' + require('@/assets/img/icon_2.png') + '"',

				conent_data: '',
				conent_title1: '',
				conent_title2: '',
				conent_title3: '',
				conent_title4: '',
				onceflag: true,

				list_link: [],
				gun_time: null,

				imgarr: []


			};
		},
		created: function() {
			console.log('首页加载开始');
			this.init_data(); //加载首页滚动图片
			this.loadLunBodata(); //加载滚动大图
		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			// window.addEventListener('resize', function() {
			//   var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
			//   if(scrolltop>0){
			//     that.fun_change_style();
			//   }
			// }, false);
		},
		methods: {
			look_news: function(url) {

				window.open(url);
			},
			goMyUrl: function(parm) {
				// console.log('跳转=' + parm);
				this.$router.push("/" + parm + "/" + GetRandom());
			},
			fun_back: function() {
				this.$emit('my-event', 'back');
			},
			init_data: function() {


				this.loadScrolldata();

				this.loadLinkdata();

			},
			loadLunBodata: function() {
				this.element_loading = true;
				this.imgarr = [];

				this.$post(
					api.http_method, Sel_Mobile('home_set', 1, 100, '', 'LK')
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res[0][0].flag == '1' && res[0][0].all_count > 0) {
						let t = res[1];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.imgarr.push(t[i]);
						}
						// console.log(this.imgarr);

					} else {
						this.$message({
							message: '还未上传 轮播图',
							type: 'success'
						});
					}


				});
			},

			loadScrolldata: function() {
				this.element_loading = true;
				this.list_min_img = [];

				this.$post(
					api.http_method, Sel_Mobile('sel_home_mode', 1, 99, 'LK-min')
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res[0].length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.list_min_img.push(t[i]);
						}
						// console.log(this.list_min_img);

						// this.scrollLeft();

					} else {
						this.$message({
							message: '还未上传 轮播图',
							type: 'success'
						});
					}


				});
			},
			scrollLeft: function() {

				let img_w = this.list_min_img.length * 180;

				// console.log('总宽=' + img_w);
				document.getElementById('content_img').animate([{
						transform: 'translateX(0px)'
					},
					{
						transform: 'translateX(-' + img_w + 'px)'
					},
					{
						transform: 'translateX(0)'
					}
				], {
					duration: 24000, //  动画时长  (单位毫秒)
					iterations: Infinity, //  重复次数  （无限循环：Infinity）
					// direction: "alternate", // 是否应该轮流反向播放动画

					fill: 'forwards', //结束时不复位
					delay: 0, // 设置动画延迟时长 (单位毫秒)
					easing: 'linear' //设置动画 运动速率  (linear: 匀速)

				});

			},
			loadLinkdata: function() {
				this.element_loading = true;
				this.list_link = [];

				this.$post(
					api.http_method, Sel_Mobile('home_link_list', 1, 99, 'link')
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res[0].length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.list_link.push(t[i]);
						}
					} else {
						this.$message({
							message: '还未上传 友情链接',
							type: 'success'
						});
					}


				});
			}


		}
	};
</script>
<style>
	.biaoti {
		width: 100%;
		height: 100px;
		background: white;
		text-align: center;
	}

	/* 关于我们 start */

	.about-us {
		max-width: 960px;
		margin: 0px;
		display: inline-flex;
		padding: 8px;
	}

	.about-left {
		display: inline-flex;
		width: 240px;
		min-width: 240px;
		flex-direction: column;

		color: #ff0000;
		padding: 10px;
		align-items: center;
		justify-self: center;
	}

	.about-right {
		display: inline-flex;
		flex-direction: column;
	}

	.about-right div {
		text-indent: 2em;
		font-size: 16px;
		line-height: 24px;
		text-align: left;
	}

	/* 关于我们 end */

	/* 图文混排 start */
	.text_image {
		width: 80%;
		margin-left: 10%;
		margin-right: calc(100% - 10%);
		padding: 5px;
		font-size: 20px;
		text-align: left;

		color: black;
		font-weight: lighter;
		word-break: break-word;
		white-space: pre-wrap;
		word-wrap: normal;
	}

	.text_image>div {
		float: left;
		clear: both;
		text-align: center;
		padding: 10px;
	}

	.text_image>div>img {
		width: 400px;
		height: auto;
	}

	.text_conent {
		width: 80%;
		padding: 5px;
		display: inline-block;
	}



	.p_one {
		margin-top: -40px;
	}

	/* 图文混排 end */

	.box {
		width: 100%;
		height: 180px;
		background: #eaeaea;
		text-align: center;
		border: 2px;
		/* margin-top: 18px; */
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}



	.box>.row {
		width: 80%;
		height: 160px;
		display: inline-block;
		overflow: hidden;

	}


	.box>.row>.content {
		float: left;
		width: auto;
		height: 160px;

	}

	.box>.row>.content>img {
		width: auto;
		height: 160px;
		display: inline-block;
		padding: 0 10px;
	}

	/* .box>.row>.content>img :nth-child(2n+1) {
    padding: 0 10px;
  } */

	.box.row>.content>img:hover {
		cursor: pointer;
	}

	.box-link {
		background: #ffffff;
		height: auto !important;
	}

	.row-link {
		border: 2px solid #cbcedd;
		margin-bottom: 10px;
		height: auto !important;
	}

	/* .chahua>img {
    width: 100%;
    height: auto;
  } */



	/* 文字+线 */
	.wrap {
		width: 96%;
		margin: 20px auto;
	}

	.grid {
		width: 100%;
		border-bottom: 1px solid #000;
		height: 20px;
		position: relative;
	}

	.grid h3 {
		width: 24%;
		line-height: 40px;
		font-size: 20px;
		text-align: center;
		background: #fff;
		position: absolute;
		top: 0px;
		left: 38%;
	}





	.content2 {
		display: inline-flex;
		width: 100%;
		justify-content: center;
		margin-top: 18px;
	}

	.c_title {
		display: inline-flex;
		align-items: flex-start;
		justify-content: center;
		flex-direction: column;
		width: 80%;
	}

	.c_title p {
		font-size: 24px;
		color: #99a9bf;
		font-weight: bold;
		line-height: 32px;
		height: 32px;
		padding: 0;
		margin: 0;
	}

	.my-link {
		display: inline-flex;
		cursor: pointer;
		padding-right: 18px;
		align-items: center;
		justify-self: center;
		border-right: 2px solid #cbcedd;
		margin: 18px;
	}


	/* 。。。。。。。。。 */
</style>